import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
// EN
import common from './en/common.json'
import wizard from './en/wizard.json'
import workspace from './en/workspace.json'
import financialModel from './en/financial-model.json'
import personnel from './en/personnel.json'
import cogs from './en/cogs.json'
import opex from './en/opex.json'
import oic from './en/oic.json'
import report from './en/report.json'
import reportBusinessPlan from './en/report-business-plan.json'
import fundraising from './en/fundraising.json'
import settings from './en/settings.json'
import twc from './en/twc.json'
import fixedAssets from './en/fixed-assets.json'
import vat from './en/vat.json'
import corporateTaxes from './en/corporate-taxes.json'
import provisions from './en/provisions.json'
import owc from './en/owc.json'
import capitalStructure from './en/capital-structure.json'
import dataset from './en/dataset.json'

// IT
import itCommon from './it/common.json'
import itWizard from './it/wizard.json'
import itWorkspace from './it/workspace.json'
import itFinancialModel from './it/financial-model.json'
import itPersonnel from './it/personnel.json'
import itCogs from './it/cogs.json'
import itOpex from './it/opex.json'
import itOic from './it/oic.json'
import itReport from './it/report.json'
import itReportBusinessPlan from './it/report-business-plan.json'
import itFundraising from './it/fundraising.json'
import itSettings from './it/settings.json'
import itTwc from './it/twc.json'
import itFixedAssets from './it/fixed-assets.json'
import itVat from './it/vat.json'
import itCorporateTaxes from './it/corporate-taxes.json'
import itProvisions from './it/provisions.json'
import itOwc from './it/owc.json'
import itDataset from './it/dataset.json'
import itCapitalStructure from './it/capital-structure.json'
import { DEFAULT_LANGUAGE, DEFAULT_NAMESPACE, FALLBACK_LANGUAGE, SUPPORTED_LANGUAGES } from './constants'

export const defaultNS = DEFAULT_NAMESPACE
export const resources = {
  en: {
    common,
    wizard,
    workspace,
    financialModel,
    personnel,
    cogs,
    opex,
    oic,
    report,
    reportBusinessPlan,
    fundraising,
    settings,
    twc,
    fixedAssets,
    vat,
    corporateTaxes,
    provisions,
    owc,
    capitalStructure,
    dataset
  },
  it: {
    common: itCommon,
    wizard: itWizard,
    workspace: itWorkspace,
    financialModel: itFinancialModel,
    personnel: itPersonnel,
    cogs: itCogs,
    opex: itOpex,
    oic: itOic,
    report: itReport,
    reportBusinessPlan: itReportBusinessPlan,
    fundraising: itFundraising,
    settings: itSettings,
    twc: itTwc,
    fixedAssets: itFixedAssets,
    vat: itVat,
    corporateTaxes: itCorporateTaxes,
    provisions: itProvisions,
    owc: itOwc,
    capitalStructure: itCapitalStructure,
    dataset: itDataset
  }
}

i18next.use(initReactI18next).init({
  resources,
  supportedLngs: SUPPORTED_LANGUAGES,
  lng: DEFAULT_LANGUAGE,
  fallbackLng: FALLBACK_LANGUAGE,
  interpolation: {
    escapeValue: false
  },
  defaultNS
})

i18next.on(`languageChanged`, lng => {
  document.documentElement.lang = lng
  localStorage.setItem(`i18nextLng`, lng)
})
